"use client"

import Link from "next/link";
import Image from "next/image";
import { cn } from "@/lib/utils";
import { useGlobalConfig, useUserVip } from "@/stores/appStore";
import { DemoMaskedText } from "@/components/demo/DemoMaskedText";

interface MarketingEntranceProps {
  collapsed: boolean;
}

export function MarketingEntrance({ collapsed }: MarketingEntranceProps) {
  const {
    vip: isVip,
  } = useUserVip();

  const {
    value: globalConfig,
  } = useGlobalConfig().globalConfig;

  const marketing = globalConfig?.pc.marketing;
  if (!marketing?.starting) return null;

  // 判断是否应该显示给当前用户
  const targetAudience = marketing.targetAudience || 'all';
  const isNormalUser = !isVip;
  const isVipUser = isVip;

  let shouldShow = false;
  if (targetAudience === 'all') {
    shouldShow = true;
  } else if (targetAudience === 'normal' && isNormalUser) {
    shouldShow = true;
  } else if (targetAudience === 'vip' && isVipUser) {
    shouldShow = true;
  }

  if (!shouldShow) return null;

  return (
    <Link
      href={marketing.marketingSurveyUrl || "/activities/2501"}
      target={marketing.marketingSurveyUrl ? '_blank' : '_self'}
      className={cn(
        "flex justify-center rounded-lg hover:bg-muted",
        collapsed ? "mx-auto h-10 w-10 items-center" : "mx-2 p-2.5"
      )}
    >
      <DemoMaskedText as="div" className="flex w-full justify-center">
        <Image
          src={marketing.entranceFoldImageUrl}
          width={18}
          height={18}
          hidden={!collapsed}
          alt=""
        />

        <Image
          src={marketing.entranceImageUrl}
          width={139}
          height={71}
          hidden={collapsed}
          className="w-full h-auto"
          alt=""
        />
      </DemoMaskedText>
    </Link>
  );
}
